var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1972_4021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 3.33203H3.33073C2.40573 3.33203 1.6724 4.0737 1.6724 4.9987L1.66406 14.9987C1.66406 15.9237 2.40573 16.6654 3.33073 16.6654H16.6641C17.5891 16.6654 18.3307 15.9237 18.3307 14.9987V4.9987C18.3307 4.0737 17.5891 3.33203 16.6641 3.33203ZM16.6641 14.9987H3.33073V9.9987H16.6641V14.9987ZM16.6641 6.66536H3.33073V4.9987H16.6641V6.66536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1972_4021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/Transactions.6e02217cc6bd888c539ba65c7169e226.svg";
export { ForwardRef as ReactComponent };